import { useRef } from "react";
import "../styles/EnrollSection/EnrollSection.css";
import CountrySelect from "../Components/enroll/CountrySelect";

const EnrollmentForm = () => {
  const formRef = useRef(null);

  // ✅ Default country code set to India
  const countryCodeRef = useRef("+91");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    // ✅ Always send country code (default +91)
    formData.append("country_code", countryCodeRef.current);
    formData.append("form_type", "Madhi Academy Enroll Form");

    try {
      const response = await fetch(
        "https://formsubmit.co/ajax/admission@madhiacademy.com",
        {
          method: "POST",
          headers: { Accept: "application/json" },
          body: formData,
        }
      );

      if (response.ok) {
        alert("Enrollment request submitted successfully!");
        formRef.current.reset();

        // Reset country code again after submit
        countryCodeRef.current = "+91";
      } else {
        alert("Submission failed. Please try again.");
      }
    } catch (error) {
      alert("Network error. Please try later.");
    }
  };

  return (
    <div className="enrollment-page-wrapper">
      {/* Header */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-xl-7">
            <h2 className="fw-bold display-5 mb-3 text-purple-dark">
              Enroll at Madhi Academy
            </h2>
            <p className="text-dark lead fs-6">
              Select your learning pathway and share your contact details.
            </p>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <section className="enrollment-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-xl-7">
              <form ref={formRef} onSubmit={handleSubmit}>
                {/* Full Name */}
                <div className="mb-4">
                  <label className="form-label text-white small">
                    Full Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    className="form-control custom-input"
                    placeholder="Enter Full Name"
                    required
                  />
                </div>

                {/* Email */}
                <div className="mb-4">
                  <label className="form-label text-white small">
                    Email ID <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control custom-input"
                    placeholder="Enter Your Mail ID"
                    required
                  />
                </div>

                {/* Mobile */}
                <div className="mb-4">
                  <label className="form-label text-white small">
                    Parent / Guardian Mobile{" "}
                    <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    {/* ✅ Country Select */}
                    <CountrySelect
                      defaultCode="+91"
                      onChange={(code) => {
                        countryCodeRef.current = code || "+91";
                      }}
                    />

                    <input
                      type="tel"
                      name="mobile"
                      className="form-control custom-input border-start-0 ps-3"
                      placeholder="Enter Mobile Number"
                      required
                    />
                  </div>
                </div>

                {/* City */}
                <div className="mb-4">
                  <label className="form-label text-white small">
                    City <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    className="form-control custom-input"
                    placeholder="Enter Your City"
                    required
                  />
                </div>

                {/* Pathway */}
                <div className="mb-4">
                  <label className="form-label text-white mb-3 small">
                    Pathway <span className="text-danger">*</span>
                  </label>

                  {[
                    "School Programs (1st–12th)",
                    "Indian Professional Courses (CA, CMA, CS)",
                    "Global Professional Courses (US CPA, US CMA, EA)",
                    "Commerce Degrees (B.Com + Professional)",
                    "Skills Training (ERP, Computer Basics, English Communication)",
                  ].map((item, index) => (
                    <div className="form-check custom-radio mb-2" key={index}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="pathway"
                        value={item}
                        required
                      />
                      <label className="form-check-label text-white small">
                        {item}
                      </label>
                    </div>
                  ))}
                </div>

                {/* Notes */}
                <div className="mb-4">
                  <label className="form-label text-white small">Notes</label>
                  <textarea
                    name="notes"
                    className="form-control custom-input"
                    rows="3"
                    placeholder="Type your message here..."
                  ></textarea>
                </div>

                {/* Consent */}
                <div className="mb-4 form-check custom-checkbox">
                  <input
                    type="checkbox"
                    name="consent"
                    value="Agreed"
                    className="form-check-input"
                    required
                  />
                  <label className="form-check-label text-white small">
                    I agree to be contacted regarding my enrollment.
                  </label>
                </div>

                {/* Hidden FormSubmit Settings */}
                <input
                  type="hidden"
                  name="_subject"
                  value="Madhi Academy Enroll Form"
                />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_template" value="table" />

                {/* Submit */}
                <div className="mb-5">
                  <button
                    type="submit"
                    className="btn btn-outline-light px-4 py-2"
                  >
                    Submit
                  </button>
                </div>
              </form>

              {/* Privacy */}
              <div className="privacy-line">
                Privacy: Your data is used only for enrollment communication.
                <span className="separator">&nbsp;|&nbsp;</span>
                Support:{" "}
                <a href="mailto:support@madhiacademy.com" className="privacy-link">
                  support@madhiacademy.com
                </a>
                <span className="separator">&nbsp;|&nbsp;</span>
                Contact with Us: 7708941960
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EnrollmentForm;
